import { render } from "./TestTokenFaucet.vue?vue&type=template&id=f11935e4&scoped=true"
import script from "./TestTokenFaucet.vue?vue&type=script&lang=js"
export * from "./TestTokenFaucet.vue?vue&type=script&lang=js"

import "./TestTokenFaucet.vue?vue&type=style&index=0&id=f11935e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f11935e4"]])

export default __exports__